// app/_shims/InText.js
// Server-safe InText shim component

import { Header } from "./semantic-ui-react";

const styles = {
  color: "#414141",
  fontWeight: "normal",
  margin: "6px 7px",
  whiteSpace: "pre-wrap",
};

const styles1 = {
  text_color: {
    color: "#000000",
    fontWeight: "normal",
    margin: "0px 7px",
  },
};

export default function InText({ name, colorClass, floated, ...props }) {
  return (
    <Header
      size="small"
      content={name}
      floated={floated}
      style={colorClass ? styles1.text_color : styles}
      {...props}
      />
  );
}
